// 9fbef606107a605d69c0edbcd8029e5d
const LOYALTY_PLACE_REWARDS_CONSTANTS = {
  SET_LOYALTY_TIER_BENEFITS: 'SET_LOYALTY_TIER_BENEFITS',
  GET_TIER_BENEFITS: 'GET_TIER_BENEFITS',
  BENEFIT_REDEEMED: 'Redeemed',
  BENEFIT_EXPIRED: 'Expired',
  BENEFIT_EXPIRING_SOON: 'Expiring Soon',
};

export default LOYALTY_PLACE_REWARDS_CONSTANTS;
